import React, { FC, ReactElement } from 'react';
import './style.scss';

interface Props {
  top: ReactElement | null;
  left: ReactElement | null;
  middle: ReactElement | null;
  styleDef?: React.CSSProperties;
}

const TopLeftContent: FC<Props> = ({ top, left, middle, styleDef }) => {
  return (
    <div className="_top_left_middle_container">
      <div className="_layout">
        <div className="_box">
          <div className="_top_box">{top}</div>
          <div className="_middle_box" style={styleDef}>
            <div className="_middle">
              <div className="_left_menu scroll_style">
                <div className="_menu_box">{left}</div>
              </div>
              <div className="_content scroll_style">{middle}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopLeftContent;
